import { list } from './data'

export default {
    list: () => [200, list],
}
